import React, { useEffect, useState } from 'react';

/**
 * "Last sold for $X on YYYY-MM-DD" — TCGPlayer-style social proof.
 * Reads /api/products/:id/last-sold (added in routes/products.js).
 */
export default function LastSold({ productId }) {
  const [last, setLast] = useState(null);

  useEffect(() => {
    if (!productId) return;
    fetch(`/api/products/${productId}/last-sold`)
      .then(r => r.ok ? r.json() : null)
      .then(d => setLast(d))
      .catch(() => {});
  }, [productId]);

  if (!last || !last.price || !last.date) return null;
  const when = new Date(last.date);
  const ago = relativeDate(when);

  return (
    <div className="last-sold" role="status">
      <strong>Last sold</strong> for ${Number(last.price).toFixed(2)} {ago}
      {last.count > 1 && <> · {last.count} purchases in last 90 days</>}
    </div>
  );
}

function relativeDate(d) {
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.round(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.round(diff / 3600)} hr ago`;
  if (diff < 86400 * 7) return `${Math.round(diff / 86400)} days ago`;
  return d.toLocaleDateString();
}
